import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["mask", "maskPlaceholder", "alwaysShowMask"],
  _excluded2 = ["custom"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import ReactInputMask from 'react-input-mask';
import { Input } from '../input';
var MaskedInput = function MaskedInput(_ref) {
  var _ref$custom = _ref.custom;
  _ref$custom = _ref$custom === void 0 ? {} : _ref$custom;
  var mask = _ref$custom.mask,
    maskPlaceholder = _ref$custom.maskPlaceholder,
    alwaysShowMask = _ref$custom.alwaysShowMask,
    custom = _objectWithoutProperties(_ref$custom, _excluded),
    props = _objectWithoutProperties(_ref, _excluded2);
  var InputMask = React.useCallback(function (inputProps) {
    return /*#__PURE__*/React.createElement(ReactInputMask, _extends({
      mask: mask,
      maskPlaceholder: maskPlaceholder,
      alwaysShowMask: alwaysShowMask
    }, inputProps));
  }, [mask, maskPlaceholder, alwaysShowMask]);
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    custom: _objectSpread(_objectSpread({}, custom), {}, {
      Input: InputMask
    })
  }));
};
export { MaskedInput };